import { ref } from 'vue';

// PostgREST/Postgres errors (bad input, RLS, constraint violations, etc.)
// always carry a non-empty `code`; a request that failed before reaching the
// server (offline, DNS, timeout) comes back with an empty one.
export function isNetworkError(error) {
  return Boolean(error) && !error.code;
}

// New records (visits, off-days, ...) created while offline — no connection,
// or a request that fails at the network level rather than being rejected by
// the server — are queued here and synced automatically once a connection is
// available again, so a dropped wifi connection during the school day
// doesn't lose anything. Editing/deleting isn't covered by this — those need
// fresh server data to reconcile against, so they just fail with an error
// while offline.
export function createPendingQueue({ storageKey, insert, onFlushed }) {
  function load() {
    try {
      return JSON.parse(localStorage.getItem(storageKey)) ?? [];
    } catch {
      return [];
    }
  }

  const items = ref(load());

  function persist() {
    localStorage.setItem(storageKey, JSON.stringify(items.value));
  }

  function queue(payloads) {
    items.value = [...items.value, ...payloads];
    persist();
  }

  async function flush() {
    if (!items.value.length || !navigator.onLine) {
      return;
    }

    const { error } = await insert(items.value);
    if (error) {
      return;
    }

    items.value = [];
    persist();
    await onFlushed?.();
  }

  return [items, queue, flush];
}
